import { useEffect, useState } from "react";
import axios from "axios";
import { Play } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const dur = (s) => (s ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}` : "");

const Tile = ({ v, big }) => {
  const [play, setPlay] = useState(false);
  const [fallback, setFallback] = useState(false);
  const poster = v.has_poster ? `${API}/media/showcase/${v.id}/poster.jpg` : undefined;
  return (
    <figure className={`group relative overflow-hidden rounded-2xl border-2 border-[#111] bg-[#111] ${big ? "md:col-span-2 md:row-span-2" : ""}`} data-testid={`showcase-video-${v.id}`}>
      <div className="relative aspect-video">
        {play ? (
          v.has_video && !fallback ? (
            <video src={`${API}/media/showcase/${v.id}/video.mp4`} poster={poster} controls autoPlay playsInline onError={() => setFallback(true)} className="absolute inset-0 h-full w-full bg-black" data-testid={`showcase-player-${v.id}`} />
          ) : (
            <iframe src={`https://player.vimeo.com/video/${v.id}?autoplay=1&title=0&byline=0&portrait=0&dnt=1`} title={v.title} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen className="absolute inset-0 h-full w-full" data-testid={`showcase-embed-${v.id}`} />
          )
        ) : (
          <button type="button" onClick={() => setPlay(true)} className="absolute inset-0 h-full w-full text-left" aria-label={`${v.title} abspielen`} data-testid={`showcase-play-${v.id}`}>
            {poster && <img src={poster} alt="" className="h-full w-full object-cover grayscale transition-transform duration-700 group-hover:scale-105" loading="lazy" />}
            <span className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <span className="absolute left-4 bottom-4 right-4 flex items-end justify-between gap-3">
              <span className="font-display font-semibold uppercase leading-tight text-white" style={{ fontSize: big ? "clamp(1.1rem,2vw,1.8rem)" : "0.95rem", color: "#fff" }}>{v.title}</span>
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#FDD105] text-[#111] shadow-[3px_3px_0_#111] transition-transform duration-300 group-hover:scale-110"><Play size={16} fill="#111" /></span>
            </span>
            {v.duration ? <span className="absolute top-3 right-3 rounded-full bg-white/90 px-2 py-0.5 text-[11px] font-bold text-[#111]">{dur(v.duration)}</span> : null}
          </button>
        )}
      </div>
    </figure>
  );
};

export const ShowcaseReel = ({ limit = 9 }) => {
  const [videos, setVideos] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => { axios.get(`${API}/media/showcase`).then((r) => setVideos(r.data.videos)).catch(() => setVideos([])); }, []);
  if (!videos || videos.length === 0) return null;
  const list = all ? videos : videos.slice(0, limit);
  return (
    <section className="shell py-16 md:py-24" data-testid="showcase-reel">
      <p className="text-[11px] uppercase tracking-[0.3em] text-[#111] mb-3 inline-block border-b-[3px] border-[#FDD105] pb-1">Aktuelle Filmproduktionen</p>
      <h2 className="font-display font-semibold uppercase tracking-tight leading-[0.95] text-4xl md:text-6xl text-[#111] mb-4">Anschauen statt<br />versprechen<span className="text-[#FDD105]">.</span></h2>
      <p className="text-base md:text-lg text-[#4A4A4A] max-w-2xl mb-10">Imagefilme, Recruiting, Werbespots, Events – {videos.length} Produktionen aus Herford und OWL. Ein Klick, läuft.</p>
      <div className="grid gap-4 md:grid-cols-3 md:auto-rows-fr">{list.map((v, i) => <Tile key={v.id} v={v} big={i === 0} />)}</div>
      {videos.length > limit && !all && <button type="button" onClick={() => setAll(true)} className="mt-8 inline-flex items-center gap-2 rounded-full border-2 border-[#111] px-6 py-3 text-sm font-semibold text-[#111] hover:bg-[#111] hover:text-white transition-colors" data-testid="showcase-more">Alle {videos.length} Filme zeigen</button>}
    </section>
  );
};
